<section class="contact-section navbar-expand-lg contact-section-color" id="contact">
    <div class="container">
        <div class = "row">
          <div class="col-md-4 mb-3 mb-md-0">
            <div class="card py-4 h-100">
              <div class="card-body text-center">
                <i class="fas fa-map-marked-alt text-primary mb-2"></i>
                <h4 class="text-uppercase m-0">Located At</h4>
                <hr class="my-4">
                <div class="small text-black-50">The Hague, The Netherlands</div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3 mb-md-0">
            <div class="card py-4 h-100">
              <div class="card-body text-center">
                <i class="fas fa-envelope text-primary mb-2"></i>
                <h4 class="text-uppercase m-0">Email</h4>
                <hr class="my-4">
                <div class="small text-black-50">
                  <a href="#">satita.ice.v@gmail.com</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3 mb-md-0">
            <div class="card py-4 h-100">
              <div class="card-body text-center">
                <i class="fas fa-mobile-alt text-primary mb-2"></i>
                <h4 class="text-uppercase m-0">Phone</h4>
                <hr class="my-4">
                <div class="small text-black-50">
                  +1(848)252-8552
                </div>
              </div>
            </div>
          </div>
        </div>
        
          <div class="social d-flex justify-content-center">
              <a href="#" class="mx-2">
                  <a href="https://www.linkedin.com/in/satita-vittayaareekul/"><i class="fab fa-linkedin"></i></a>
              </a>
              <a href="#" class="mx-2">
                  <a href="https://github.com/SatitaVitt"><i class="fab fa-github"></i> </a>
              </a>
          </div>
  </div>
  <footer class="small text-center text-white-50">
    <div class="container">
      Copyright &copy; Satita's Website 2023
    </div>
  </footer>
</section>